// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"financialsBox_wrapper__2ZWdM","table":"financialsBox_table__3jdE5"};